import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';

import s from './Vision.css';
import cs from '../../commonStyle.css';
import cx from 'classnames';
import {Row, Col } from 'react-bootstrap';
import messages from '../../../locale/messages';

import vision_img from '/images/our-vision.jpg';

class Vision extends Component {
  render() {
    const { title, content, imageUrl } = this.props;
    return (
      <>
      <div className={cx(s.vision)}>
        <div className={s.container}>
          <Row>
            <Col xs={12} sm={5} md={4} lg={4}>
              <h1 className={cx(s.title, s.iconTitleThird)}>
                {/* <FormattedMessage {...messages.ourVision} /> */}
                {title}
              </h1>
              <div className={s.content}>
                <p>
                  {content}
                </p>
              </div>
            </Col>
            <Col xs={12} sm={7} md={8} lg={8}>
                <div className={s.visionImage}>
                    <img src={imageUrl} alt="vision-img" />
                </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
  }
}

export default withStyles(s, cs)(Vision);